import { render, staticRenderFns } from "./YextSettingsCard.vue?vue&type=template&id=409caad4"
import script from "./YextSettingsCard.vue?vue&type=script&lang=ts"
export * from "./YextSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports